<template>
  <span>
    <OverlayPanel ref="op" class="download-op" style="width: 200px">
      <div v-if="emptyLanguages" class="just-text">{{ $t('report.no_report_available') }}</div>
      <div v-for="lang of languages" :key="'downloadreport_'+lang.code"
           @click="downloadLang($event, lang.code)"
           :style="{display: lang.display ? 'block' : 'none'}">
        {{ lang.name }}
      </div>
    </OverlayPanel>

    <IrinoxDialogDark :visible="dialog.error"
      mode="error"
      :message="$t('report.error_dialog')"
      :life="3000"
      @update:visible="dialog.error = $event" />
    <IrinoxDialogDark :visible="dialog.success"
      mode="success"
      :message="$t('report.download_report_success')"
      :life="3000"
      @update:visible="dialog.success = $event" />
  </span>
</template>

<script>
import ReportService from '../../service/ReportService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ReportDownloadOverlay',
  components: {
    IrinoxDialogDark,
  },
  data() {
    return {
      currentReport: {
        reportId: null,
        serialNumber: null,
      },
      languages: [
        { code: 'en_GB', name: 'English', display: true },
        { code: 'it_IT', name: 'Italiano', display: true },
        { code: 'ru_RU', name: 'русский', display: false },
        { code: 'es_ES', name: 'Español', display: false },
        { code: 'nl_NL', name: 'Nederlands', display: false },
        { code: 'fr_FR', name: 'Français', display: false },
        { code: 'de_DE', name: 'Deutsche', display: false },
        { code: 'en_US', name: 'United States', display: false },
        { code: 'ja_JP', name: 'やまと', display: false },
        { code: 'pt_BR', name: 'Português', display: false },
        { code: 'ko_KR', name: '한국어', display: false },
        { code: 'hi_IN', name: 'हिंदी', display: false },
        { code: 'id_ID', name: 'Bahasa Indonesia', display: false },
        { code: 'zh_CN', name: '中文', display: false },
      ],
      dialog: {
        error: false,
        success: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
    }),
    emptyLanguages() {
      for (let lang of this.languages) {
        if (lang.display) {
          return false;
        }
      }
      return true;
    },
  },
  created() {
    this.reportService = new ReportService();
  },
  methods: {
    open(event, serialNumber, reportId, language) {
      this.currentReport.serialNumber = serialNumber;
      this.currentReport.reportId = reportId;
      for (let lang of this.languages) {
        lang.display = language != null && language.includes(lang.code);
      }
      this.$refs.op.toggle(event);
    },
    downloadLang(event, lang) {
      this.$refs.op.toggle(event);
      this.reportService.download(this.personaltoken, this.currentReport.reportId, lang)
        .then((res) => {
          this.dialog.success = true;
          let blob = new Blob([res.data], { type: 'application/pdf' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'report_' + this.currentReport.serialNumber + '_' + this.currentReport.reportId + '_' + lang + '.pdf';
          link.click();
        })
        .catch((error) => {
          console.error('EXCEPTION ' + error);
          this.dialog.error = true;
        });
    },
  },
};
</script>

<style scoped>
.download-op div {
  cursor: pointer;
  padding: 4px 0;
}
.download-op .just-text {
  cursor: default;
}
</style>
